// helper funcs for fetch requests
const handleFetchResponse = response => {
  if (!response.ok) throw new Error(`HTTP Error ${response.status}`);
  return response.json();
};

const handleCommandResultErrors = responseJson => {
  if (responseJson.hasErrors) {
      const msg = responseJson.errors.map(x => x.errorMessage).join('||');
      alert(msg);

      throw new Error(msg);
  }

  return Promise.resolve(responseJson);
};

const handleFetchErrors = e => {
  alert(`Fetch Error -> ${e.toString()}`)
};

export const getResponseJson = response => {
  return handleFetchResponse(response)
    .then(handleCommandResultErrors);
};

export default getResponseJson;
